import { render, staticRenderFns } from "./product-price-dialog.vue?vue&type=template&id=5855f6c4&"
import script from "./product-price-dialog.vue?vue&type=script&lang=js&"
export * from "./product-price-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports